import { useContext } from 'react'
import { IntegrationContext } from './IntegrationContextDef'

export function useIntegrationContext() {
  const context = useContext(IntegrationContext)
  if (context === undefined) {
    throw new Error('useIntegrationContext must be used within an IntegrationProvider')
  }
  return context
}
